import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\ListImportController::__invoke
* @see app/Http/Controllers/Import/ListImportController.php
* @route '/api/import'
*/
const ListImportController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ListImportController.url(options),
    method: 'get',
})

ListImportController.definition = {
    methods: ["get","head"],
    url: '/api/import',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Import\ListImportController::__invoke
* @see app/Http/Controllers/Import/ListImportController.php
* @route '/api/import'
*/
ListImportController.url = (options?: RouteQueryOptions) => {
    return ListImportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\ListImportController::__invoke
* @see app/Http/Controllers/Import/ListImportController.php
* @route '/api/import'
*/
ListImportController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ListImportController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Import\ListImportController::__invoke
* @see app/Http/Controllers/Import/ListImportController.php
* @route '/api/import'
*/
ListImportController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ListImportController.url(options),
    method: 'head',
})

export default ListImportController